import { createElement, Fragment } from 'react'

import type { GetLayout, Location } from '@app/packages/routing/types'

export const mapEventData = (map: Record<string, string>) => async (_location: Location, params: Record<string, any>) => {
  const data: Record<string, any> = {}
  for (const [targetKey, paramKey] of Object.entries(map)) {
    const val = params[paramKey]
    if (val) data[targetKey] = val
  }
  return data
}

export const emptyLayout: GetLayout = ({ children }) => createElement(Fragment, undefined, children)

const REGION_CHANGE = 'f464dbc7-08d6-43d5-b2de-cf1598e35290_region_change'
export const getRegionChange = (state: {}) => state[REGION_CHANGE] as string | undefined
export const withRegionChange = <T extends {}>(state: T, val: string) => {
  state[REGION_CHANGE] = val
  return state
}
export const withoutRegionChange = <T extends {}>(state: T) => {
  return { ...state, [REGION_CHANGE]: undefined }
}
